<template>
    <el-dialog title="订单价格修改" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="500px">
        <el-form size="small" ref="form" :model="form" label-width="100px">
          <el-form-item label="收货人" prop="name" :rules="[{required: true,message: '请填写收货人'}]">
            <el-input v-model="form.name" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="收货电话" prop="phone" :rules="[{required: true,message: '请填写收货电话'}]">
            <el-input v-model="form.phone" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="收货地址(省/市/区)" prop="region_id" :rules="[{required: true,message: '请填写选择省市区'}]">
            <el-select v-model="form.province_id" placeholder="省" @change="initCity">
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
            </el-select>
            <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
              <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
                :key='index1'></el-option>
            </el-select>
            <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
              <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
                :key='index2'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" prop="detail" :rules="[{required: true,message: '请填写详细地址'}]">
            <el-input v-model="form.detail" class="max-w460"></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="submitFunc()" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import OrderApi from '@/api/order.js';
    export default {
        data() {
            return {
              /*省市区*/
              areaList: {},
              order_id: 0,
              loading: false,
              /*左边长度*/
              formLabelWidth: '100px',
              /*是否显示*/
              dialogVisible: true,
              /*表单*/
              form: {
                name: '',
                phone: '',
                detail: '',
                province_id: '',
                city_id: '',
                region_id: '',
              }
            };
        },
        props: ['detail'],
        created() {
            this.order_id = this.detail.order_id;
            this.form = {
              name: this.detail.address.name,
              phone: this.detail.address.phone,
              detail: this.detail.address.detail,
              province_id: this.detail.address.province_id,
              city_id: this.detail.address.city_id,
              region_id: this.detail.address.region_id,
            }
            
            this.getArea();
        },
        methods: {
          // 获取城市
          getArea(){
            let self = this;
            OrderApi.getArea({}, true)
            .then(res => {
              self.areaList = res.data.regionData;
            })
            .catch(error => {

            });
          },
          /*初始化城市id*/
          initCity() {
            this.form.city_id = ''
          },

          /*初始化区id*/
          initRegion() {
            this.form.region_id = ''
          },
          /*确认事件*/
          submitFunc(e) {
              let self = this;
              let data = this.form;
              self.$refs.form.validate((valid) =>
              {
                  if (valid) {
                      self.loading = true;
                      OrderApi.updateAddress({
                          order_id: this.order_id,
                          data: data,
                      }, true).then(data =>
                      {
                          self.loading = false;
                          self.$message({
                              message: '修改成功',
                              type: 'success'
                          });
                          self.dialogFormVisible(true);
                      }).catch(error =>
                      {
                          self.loading = false;
                      });
                  }
              });
          },

          /*关闭弹窗*/
          dialogFormVisible() {
              this.$emit('close', {openDialog: false});
          }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Address.vue